// I link hardcoded nei settings non avevano il prefisso lingua → in /it riportavano alla versione EN.
// Prefissa i link interni relativi con la locale corrente (Shopify.routes.root). I link gia' localizzati o speciali sono saltati.
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  if (root === "/") return; // lingua primaria: nessun prefisso
  var prefix = root.replace(/\/+$/, ""); // es. "/it"
  function localize() {
    var links = document.querySelectorAll('a[href^="/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], h = a.getAttribute("href");
      if (!h || h.charAt(0) !== "/" || h.charAt(1) === "/") continue;      // protocol-relative
      if (h === prefix || h.indexOf(prefix + "/") === 0) continue;          // gia' localizzato
      if (h.indexOf("/cdn/") === 0) continue;                               // asset
      a.setAttribute("href", prefix + h);
    }
  }
  localize();
  document.addEventListener("DOMContentLoaded", localize);
})();
